import React from 'react';

/** Resumen de privacidad alineado con la política PL.PIGPDP.01; el detalle jurídico está en la pestaña de tratamiento. */
const contenidoPoliticaPrivacidad = () => {
  return (
    <div className="politica-privacidad text-body" style={{ fontSize: '0.875rem', lineHeight: 1.65 }}>
      <p className="mb-2 text-justify">
        <strong style={{ fontWeight: 'bold', fontSize: '14px !important' }}>PARKING INTERNATIONAL S.A.S.</strong>, identificada con NIT 860.058.760-1, con domicilio en Carrera 14 No.
        89 – 48 oficina 202, Edificio Novanta, Bogotá D.C., Colombia, trata sus datos personales conforme a la Ley 1581 de
        2012, el Decreto 1377 de 2013 y normas concordantes, con fines lícitos descritos en la autorización que usted
        otorga en cada relación (contrato, formulario, plataforma o canal equivalente).
      </p>
      <p className="mb-2 text-justify">
        La confidencialidad, la seguridad de la información y el respeto a los derechos de los titulares (conocer,
        actualizar, rectificar, suprimir cuando proceda y revocar la autorización según la ley) son principios que guían
        nuestro tratamiento. El texto completo de obligaciones, finalidades por tipo de titular, transmisión,
        transferencia y procedimientos de hábeas data está en la pestaña <strong>Tratamiento de datos</strong> de este
        mismo aviso, documento código <strong>PL.PIGPDP.01</strong> (versión 2, 16 de septiembre de 2024).
      </p>
      <h6 className="text-dark mt-3 mb-2 fw-semibold">Canales de atención (consultas y reclamos)</h6>
      <p className="mb-1 ms-2">• Teléfono: 57(1) 5190077</p>
      <p className="mb-1 ms-2">
        • Correo electrónico:{' '}
        <a href="mailto:oficial.protecciondatos@parking.net.co">oficial.protecciondatos@parking.net.co</a>
        {' — '}
        <a href="mailto:administracion@parking.net.co">administracion@parking.net.co</a>
      </p>
      <p className="mb-1 ms-2">
        • Dirección física: Carrera 14 No. 89 – 48 oficina 202, edificio Novanta, Bogotá D.C.
      </p>
      <p className="mb-2 ms-2">
        • Página web:{' '}
        <a href="https://www.parking.net.co/#/" target="_blank" rel="noopener noreferrer">
          https://www.parking.net.co/#/
        </a>
      </p>
      <p className="mb-0 small text-muted text-justify">
        Si considera que no hemos dado trámite adecuado a su petición, puede acudir a la Superintendencia de Industria y
        Comercio —Delegatura de Protección de Datos Personales— conforme a la normativa vigente.
      </p>
    </div>
  );
}

export default contenidoPoliticaPrivacidad;